import React from 'react';
import PropTypes from 'prop-types';
import FileUploaded from '~/components/FileUploaded';
import { PLACEHOLDER_IMAGE } from '~/config/constants';
import PreviewAsBackground from '~/components/FileUploaded/picture-preview/PreviewAsBackground';
import { formLabel } from '~/utils/helpers';
import { useField } from 'formik';
import { FormFeedback } from '~/components/FormControl';
import isEmpty from 'lodash/isEmpty';

function CardBack({ pictureName, pictureVal, resetCount, id }) {
    const [tempUrl, setTempUrl] = React.useState(pictureVal);
    const pictureUrl = tempUrl || PLACEHOLDER_IMAGE;

    const inputEl = React.useRef(null);

    React.useEffect(() => {
        setTempUrl(pictureVal);
    }, [resetCount]);
    const [, form] = useField(pictureName);

    return (
        <FileUploaded
            pictureName={pictureName}
            formFileClass={'position-absolute wd-zero z-n1'}
            setTempUrl={setTempUrl}
            inputEl={inputEl}
        >
            <FileUploaded.Preview>
                <PreviewAsBackground
                    pictureUrl={pictureUrl}
                    inputEl={inputEl}
                    id={id}
                />
                <figcaption>{formLabel(pictureName)}</figcaption>
                <FormFeedback
                    isInvalid={!isEmpty(form.error)}
                    errorMessage={form.error}
                    className={'text-center'}
                />
            </FileUploaded.Preview>
        </FileUploaded>
    );
}

CardBack.propTypes = {
    pictureName: PropTypes.string.isRequired,
    pictureVal: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired, //PropTypes.object is when new picture is uploaded.
    resetCount: PropTypes.number.isRequired,
    id: PropTypes.string.isRequired,
};
export default React.memo(CardBack);
